import PlayIcon from "@/icons/PlayIcon";
import CheckCircleIcon from "@/icons/CheckCircleIcon";
import ExclamationIcon from "@/icons/ExclamationIcon";
import ClockIcon from "@/icons/ClockIcon";
import PauseIcon from "@/icons/PauseIcon";

const STATUS_OPTIONS = [
  {
    label: "не начат",
    value: "magenta",
    icon: <ClockIcon />,
  },
  {
    label: "в работе",
    value: "blue",
    icon: <PlayIcon />,
  },
  {
    label: "удален",
    value: "red",
    icon: <ExclamationIcon />,
  },

  {
    label: "завершен",
    value: "green",
    icon: <CheckCircleIcon />,
  },
  {
    label: "отложен",
    value: "purple",
    icon: <PauseIcon />,
  },
];

const FILTER_NAMES = {
  SEARCH: "search", // поиск
  AUTHOR_UUID: "author_uuid", // автор
  UNIT_UUID: "unit_uuid", // рабочая группа
  UNITS_UUIDS: "units_uuids", // рабочие группы (для пользователя)
  ACCESS_LEVEL: "access_level", // уровень доступа (для пользователя)
};

const getInitialTableParams = (unitUuid) => ({
  pagination: {
    current: 1,
    pageSize: 10,
    position: ["bottomLeft"],
    showSizeChanger: true,
  },
  filters: {
    search: null,
    unit_uuid: unitUuid || null,
    units_uuids: [],
    author_uuid: null,
    access_level: "all",
  },
  sort: [
    {
      columnKey: "name",
      field: "name",
      order: "ascend",
    },
  ],
});

const LOCAL_STORAGE_KEY = "sprintsTableParams";

const getLocalStorageKey = (userUuid, unitUuid, isAdmins) =>
  `${userUuid}_${LOCAL_STORAGE_KEY}_${unitUuid || ""}_${
    isAdmins ? "admins" : ""
  }`;

export {
  STATUS_OPTIONS,
  FILTER_NAMES,
  LOCAL_STORAGE_KEY,
  getInitialTableParams,
  getLocalStorageKey,
};
